
    // const hotspotIcons = document.querySelectorAll('.hotspot-icon-container');
    // const productContainers = document.querySelectorAll('.hotspot-product-container');

    // hotspotIcons.forEach(icon => {
    //   icon.addEventListener('click', function() {
    //     icon.classList.toggle('hotspot-active');

    //     const productToShow = this.dataset.product;

    //     productContainers.forEach(container => {
    //       if (container.classList.contains(`hotspot-product-container--${productToShow}`)) {
    //         container.style.display = container.style.display === 'block' ? 'none' : 'block';
    //       } else {
    //         container.style.display = 'none';
    //       }
    //     });
    //   });
    // });

    const hotspotIcons = document.querySelectorAll('.hotspot-icon-container');
    const productContainers = document.querySelectorAll('.hotspot-product-container');
    
    hotspotIcons.forEach(icon => {
      icon.addEventListener('click', function(event) {
        event.stopPropagation(); // Prevent the document click event from firing when clicking the icon
        icon.classList.toggle('hotspot-active');
    
        const productToShow = this.dataset.product;
    
        productContainers.forEach(container => {
          if (container.classList.contains(`hotspot-product-container--${productToShow}`)) {
            container.style.display = container.style.display === 'block' ? 'none' : 'block';
          } else {
            container.style.display = 'none';
          }
        });
    
        // Add event listener to the document to close the hotspot when clicking outside
        document.addEventListener('click', closeHotspotOnClickOutside);
      });
    });
    
    function closeHotspotOnClickOutside(event) {
      let clickInsideHotspot = false;
    
      hotspotIcons.forEach(icon => {
        if (icon.contains(event.target)) {
          clickInsideHotspot = true;
        }
      });
    
      productContainers.forEach(container => {
        if (container.contains(event.target)) {
          clickInsideHotspot = true;
        }
      });
    
      if (!clickInsideHotspot) {
        productContainers.forEach(container => {
          container.style.display = 'none';
        });
    
        hotspotIcons.forEach(icon => {
          icon.classList.remove('hotspot-active');
        });
    
        document.removeEventListener('click', closeHotspotOnClickOutside); // Remove the event listener after closing the hotspot
      }
    }
    

